export default __webpack_public_path__ + "static/media/Caravan Master's Necklace.251a436c.jpg";